import React, { useState } from 'react'
import { Box, Checkbox, Typography, useTheme } from '@mui/material'
import GenericModal from '../GenericModal'
import { yellow } from '../../colors'

interface ResetClassrankedAuthConfirmationModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: (deleteForAll: boolean) => Promise<void>
  isSubmitting?: boolean
  bodyText: string
}

const ResetClassrankedAuthConfirmationModal: React.FC<ResetClassrankedAuthConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isSubmitting = false,
  bodyText
}) => {
  const theme = useTheme()
  const [isWarningChecked, setIsWarningChecked] = useState(false)

  const handleClose = (): void => {
    setIsWarningChecked(false)
    onClose()
  }

  return (
    <GenericModal
      isOpen={isOpen}
      onClose={handleClose}
      onConfirm={async () => { await onConfirm(isWarningChecked) }}
      title='Reset ClassRanked Authentication Access'
      confirmActionText='Reset Access'
      confirmButtonLoading={isSubmitting}
      destructiveButtonDisabled={isSubmitting}
      confirmButtonDisabled={isSubmitting}
    >
      <Typography fontSize='14px' color='text.secondary'>
        {bodyText}
      </Typography>

      <Box
        display='flex'
        flexDirection='column'
        alignItems='flex-start'
        mt={theme.spacing(3)}
        p={theme.spacing(4)}
        border={`3px solid ${yellow[150]}`}
        borderRadius={2}
      >
        <Typography fontWeight='bold'>Warning!</Typography>
        <Box display='flex' flexDirection='row' alignItems='center' mt={theme.spacing(2)}>
          <Checkbox
            checked={isWarningChecked}
            onChange={() => { setIsWarningChecked(prev => !prev) }}
            disabled={isSubmitting}
          />
          <Typography fontSize={theme.spacing(3.5)}>
            Disable Classranked Authentication for all users (Account Owners and System Managers are unaffected)
          </Typography>
        </Box>
      </Box>
    </GenericModal>
  )
}

export default ResetClassrankedAuthConfirmationModal
